export default __webpack_public_path__ + "16eb5dbcb26db0ce97d9c0e398400413.jpg";